<template>
  <v-container v-if="nets" class="grey lighten-5" fluid>
    <nets-filters :nets="nets"/>
    <time-series-graph/>
    <chart-options/>
  </v-container>
</template>

<script>
import NetsFilters from "@/components/NetsFilters"
import TimeSeriesGraph from "@/components/TimeSeriesGraph"
import ChartOptions from "@/components/ChartOptions"
import api from '@/api'

export default {
  components: {
    netsFilters: NetsFilters,
    timeSeriesGraph: TimeSeriesGraph,
    chartOptions: ChartOptions
  },
  props: {
    source: String
  },
  data: () => ({
    sensorID: null, 
    drawer: null,
    nets: null,
  }),
  computed:{
  },
  mounted: async function() {
    try{
        this.nets = await api.netsdetail()
      } catch (error){
        console.log(error)
        this.$store.commit('logout')
        this.$router.push('Welcome')
      }
    }
};
</script>
